export default __webpack_public_path__ + "static/media/play-icon-white.ec080819.svg";